import React from 'react';
import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconMessage } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { isChatDisabled } from '../../functions';
/**
 * Composant interne pour gérer le badge du chat overlay.
 */
function ChatButtonWithBadge({ children }) {
    const [overlayUnreadCount, setOverlayUnreadCount] = useState(0);
    useEffect(() => {
        const storedCount = localStorage.getItem('overlayChatUnreadCount');
        if (storedCount) {
            setOverlayUnreadCount(parseInt(storedCount, 10));
        }
        // Écouter les mises à jour via CustomEvent
        const handleUnreadCountUpdate = (event) => {
            setOverlayUnreadCount(event.detail);
        };
        // Écouter les changements de localStorage (pour les autres onglets)
        const handleStorageChange = (event) => {
            if (event.key === 'overlayChatUnreadCount' && event.newValue) {
                setOverlayUnreadCount(parseInt(event.newValue, 10));
            }
        };
        // Réinitialiser le badge quand le chat s'ouvre
        const handleChatToggle = () => {
            setOverlayUnreadCount(0);
            localStorage.setItem('overlayChatUnreadCount', '0');
        };
        window.addEventListener('overlayChatUnreadCount', handleUnreadCountUpdate);
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('TOGGLE_CHAT_OVERLAY', handleChatToggle);
        return () => {
            window.removeEventListener('overlayChatUnreadCount', handleUnreadCountUpdate);
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('TOGGLE_CHAT_OVERLAY', handleChatToggle);
        };
    }, []);
    return (React.createElement("div", { className: "toolbar-button-with-badge", key: "chatcontainer" },
        children,
        overlayUnreadCount > 0 && (React.createElement("span", { style: {
                backgroundColor: '#4A5568',
                borderRadius: '100%',
                height: '16px',
                minWidth: '16px',
                color: 'white',
                fontSize: '0.625rem',
                fontWeight: 700,
                pointerEvents: 'none',
                position: 'absolute',
                right: '-4px',
                top: '-3px',
                textAlign: 'center',
                padding: '1px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: '1'
            } }, overlayUnreadCount > 99 ? '99+' : overlayUnreadCount))));
}
/**
 * Implementation of a button for accessing chat pane.
 */
class ChatButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.openChat';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.closeChat';
    icon = IconMessage;
    label = 'toolbar.openChat';
    toggledLabel = 'toolbar.closeChat';
    tooltip = 'toolbar.openChat';
    toggledTooltip = 'toolbar.closeChat';
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._chatOpen;
    }
    /**
     * Overrides AbstractButton's {@link Component#render()}.
     *
     * @override
     * @protected
     * @returns {boReact$Nodeolean}
     */
    render() {
        return (React.createElement(ChatButtonWithBadge, null, super.render()));
    }
    /**
     * Handles clicking the button, and toggles the chat.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        sendAnalytics(createToolbarEvent('toggle.chat', {
            enable: !this.props._chatOpen
        }));
        dispatch(closeOverflowMenuIfOpen());
        if (typeof window !== 'undefined') {
            window.postMessage({ type: 'TOGGLE_CHAT_OVERLAY' }, '*');
            window.dispatchEvent(new CustomEvent('TOGGLE_CHAT_OVERLAY'));
        }
        // dispatch(toggleChat());
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        _chatOpen: state['features/chat'].isOpen,
        visible: !isChatDisabled(state)
    };
};
export default translate(connect(mapStateToProps)(ChatButton));
